import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["mobile-filter-position"]
  static targets = ["announcement"]

  connect() {
    this.position = 0
  }

  collapse() {
    let translate = 0

    // The AnnouncementTarget can be removed from a page
    // We need to fetch height every call
    const announcementHeight = this.hasAnnouncementTarget ? this.announcementTarget.clientHeight : 0
    const navbarHeight = this.element.clientHeight

    const newPosition = window.scrollY

    const shouldHideAnnouncement = this.hasAnnouncementTarget ? newPosition > announcementHeight : true
    const shouldHideNavbar = newPosition > navbarHeight && this.scrollDirection(newPosition) === "up"

    if (shouldHideAnnouncement) translate = announcementHeight
    if (shouldHideNavbar) translate = navbarHeight

    if (this.hasMobileFilterPositionOutlet)
      this.mobileFilterPositionOutlet.updateFilterPosition(shouldHideNavbar, announcementHeight, navbarHeight)

    this.position = newPosition
    this.element.style.transform = translate ? `translateY(-${translate}px)` : "none"
  }

  // The scrollDelta could be a positive or negative number.
  // -1: scrolling down
  // +1: scrolling up
  scrollDirection(newPosition) {
    const scrollDelta = newPosition - this.position
    return scrollDelta > 0 ? "up" : "down"
  }
}
